document.addEventListener("DOMContentLoaded", function(event) {
  
  // Make the Ajiri Foundation link in the nav to open in a new tab instead of the current one
  
  var foundationLink = document.querySelector("a[href$='ajirifoundation.org'");
  foundationLink?.setAttribute('target','_blank');
  
});